<template>
  <v-app-bar
    absolute
    app
    color="transparent"
    flat
    height="75"
    style="width: auto;"
  >
    <v-btn
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : toggleMini()"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <!-- <v-toolbar-title
      class="hidden-sm-and-down"
      v-text="$route.name"
    />-->

    <v-spacer />

    <!-- <v-text-field
      :label="$t('search')"
      color="secondary"
      hide-details
      class="mb-2"
      style="max-width: 165px;"
    >
      <template
        v-if="$vuetify.breakpoint.mdAndUp"
        v-slot:append-outer
      >
        <v-btn
          class="mt-n2"
          fab
          small
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field>-->

    <div class="mx-3" />

    <!-- <v-btn min-width="0" text>
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>-->

    <!-- <v-menu bottom left offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn min-width="0" text v-bind="attrs" v-on="on">
          <v-badge color="red" overlap>
            <template v-slot:badge>
              <span class="caption">5</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <div>
          <app-bar-item v-for="(n, i) in notifications" :key="`item-${i}`">
            <v-list-item-title v-text="n" />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>-->
    <v-btn
      text
      @click="GoToSupport"
    >
      <v-icon>mdi-phone-ring</v-icon>
    </v-btn>

    <v-btn
      v-if="showBasket"
      min-width="0"
      text
      @click="GoToBasket"
    >
      <v-icon class="mr-2">
        mdi-basket
      </v-icon> Your basket ({{ basketItems.length }})
    </v-btn>

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="mr-2">
            mdi-account
          </v-icon>
          {{ user.UserName }}
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <template v-for="(item, i) in computedItems">
          <app-bar-item
            :key="`item-${i}`"
            :title="$t(item.title)"
            @click.native="execute(item.func)"
          >
            <v-list-item-title>
              <v-icon class="mr-3">
                {{ item.icon }}
              </v-icon>
              <span>{{ $t(item.title) }}</span>
            </v-list-item-title>
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>
    <change-password-dialog
      :visible="changePasswordDialog"
      @close="handleChangePasswordClose"
    />
  </v-app-bar>
</template>

<script>
// Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import objectHelper from '@/helpers/objectHelper'

  import ChangePasswordDialog from '@/components/custom/dialogs/ChangePassword.vue'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      ChangePasswordDialog,
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(
                  VListItem,
                  {
                    attrs: this.$attrs,
                    class: {
                      'black--text': !hover,
                      'white--text secondary elevation-12': hover,
                    },
                    props: {
                      activeClass: '',
                      dark: hover,
                      link: true,
                      ...this.$attrs,
                    },
                  },
                  this.$slots.default
                )
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      changePasswordDialog: false,
      items: [
        {
          icon: 'mdi-shopping',
          title: 'General.Menus.AppBar.ViewResellerProfile',
          permissions: ['OperatorAdmin', 'ResellerAdmin'],
          func: 'showResellerProfile',
        },
        {
          icon: 'mdi-account-circle',
          title: 'General.Menus.AppBar.ViewUserProfile',
          func: 'showUserProfile',
        },
        {
          icon: 'mdi-form-textbox-password',
          title: 'General.Menus.AppBar.ChangePassword',
          func: 'showChangePassword',
        },
        {
          icon: 'mdi-location-exit',
          title: 'General.Menus.AppBar.LogOut',
          func: 'Logout',
        },
      ],
    }),

    computed: {
      ...mapState({
        drawer: state => state.ui.drawer,
        basketItems: state => state.orders.basket.items,
        user: state => state.security.user.profile,
      }),
      ...mapGetters(['userHasAccess']),
      showBasket () {
        return this.basketItems.length > 0 && this.basketItems.find(item => {
          return objectHelper.objectHasNonDefaultFields(item)
        }) != null
      },
      computedItems () {
        return this.items
          .filter(i => this.userHasAccess(i.permissions))
          .map(this.mapItem)
      },
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
        toggleMini: 'TOGGLE_DRAWER_MINI',
      }),
      execute (func) {
        this[func]()
      },
      Logout () {
        this.$store.dispatch('Logout')
      },
      GoToBasket () {
        this.$router.push('/order')
      },
      GoToSupport () {
        this.$router.push('/support')
      },
      showChangePassword () {
        this.changePasswordDialog = true
      },
      handleChangePasswordClose () {
        this.changePasswordDialog = false
      },
      showResellerProfile () {
        this.$router.push({ name: 'ResellerProfile' })
      },
      showUserProfile () {
        this.$router.push({ name: 'UserProfile' })
      },
      handleActions (type) {
        console.log('handleActions', type)
      },
      mapItem (item) {
        return {
          ...item,
          children: item.children
            ? item.children
              .filter(i => this.userHasAccess(i.permissions))
              .map(this.mapItem)
            : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>
